const safeParse = (value, fallback = {}) => {
  try {
    return JSON.parse(value || '');
  } catch (error) {
    return fallback;
  }
};

export const getSessionContext = () => {
  const user = safeParse(localStorage.getItem('user'), {});
  const company = safeParse(localStorage.getItem('company'), {});
  const permissions = Array.isArray(user?.permissions) ? user.permissions : [];

  let subdomain =
    company?.subdomain ||
    company?.company_sub_domain ||
    user?.company_sub_domain ||
    user?.company?.subdomain ||
    user?.company_subdomain ||
    '';

  if (!subdomain && typeof window !== 'undefined' && window.location) {
    const hostParts = window.location.hostname.split('.');
    if (hostParts.length > 1 && hostParts[0] !== 'localhost' && hostParts[0] !== '127') {
      subdomain = hostParts[0];
    }
  }

  const companyId = company?.id || user?.company_id || user?.company?.id || '';

  return {
    user,
    company,
    permissions,
    subdomain,
    companyId,
  };
};
